import { useMutation } from '@tanstack/react-query';
import { ApiClient, apiPaths, useApiErrorStoreActions } from '@repo/api/client';
import { loanSignVerifySuccessResponseBodySchema } from './loan-sign-verify.schema';
var apiEndpoint = apiPaths.loan.sign.verify;
function postLoanSignVerify(payload) {
    return ApiClient.fetch(apiEndpoint.path, {
        options: { method: 'POST', body: JSON.stringify(payload) },
        successSchema: loanSignVerifySuccessResponseBodySchema,
    });
}
export function usePostLoanSignVerify() {
    var setApiError = useApiErrorStoreActions().setApiError;
    return useMutation({
        retry: false,
        mutationFn: postLoanSignVerify,
        onError: function (error) {
            setApiError({
                apiPathId: apiEndpoint.id,
                error: error,
            });
        },
    });
}
